module.exports = __webpack_public_path__ + "img/qt.9684a548.png";